import SectionHeading from "@/pages/home/components/SectionHeading";
import { collections } from "@/mocks/home";

const accentStyles: Record<string, { badge: string; chip: string; dot: string }> = {
  primary: {
    badge: "bg-primary-100 text-primary-800",
    chip: "bg-primary-50 text-primary-800 border-primary-200/70",
    dot: "bg-primary-500",
  },
  accent: {
    badge: "bg-accent-100 text-accent-800",
    chip: "bg-accent-50 text-accent-800 border-accent-200/70",
    dot: "bg-accent-500",
  },
  secondary: {
    badge: "bg-secondary-100 text-secondary-800",
    chip: "bg-secondary-50 text-secondary-800 border-secondary-200/70",
    dot: "bg-secondary-500",
  },
};

export default function CollectionsSection() {
  return (
    <section id="collections" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="主题合集"
          title="按一条线索打包看，省去反复搜索"
          desc="合集把同一主题或同一节奏的影片聚在一起，想连着看时直接顺着一条线挑，比一部一部搜要快得多。"
        />

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-5">
          {collections.map((col) => {
            const style = accentStyles[col.accent];
            return (
              <article
                key={col.id}
                className="rounded-lg border border-background-200/80 bg-background-50 p-5 md:p-6"
              >
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <span
                      className={`inline-flex items-center h-6 px-2.5 rounded-md text-xs font-label font-medium ${style.badge}`}
                    >
                      {col.count}
                    </span>
                    <h3 className="mt-3 font-heading text-lg md:text-xl font-bold text-foreground-950">
                      {col.title}
                    </h3>
                  </div>
                  <span
                    className={`w-10 h-10 flex items-center justify-center rounded-md shrink-0 ${style.badge}`}
                  >
                    <i className="ri-stack-line text-xl" />
                  </span>
                </div>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  {col.desc}
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {col.items.map((item) => (
                    <span
                      key={item}
                      className={`inline-flex items-center gap-1.5 h-7 px-2.5 rounded-md border text-xs font-label ${style.chip}`}
                    >
                      <span className={`w-1 h-1 rounded-full ${style.dot}`} />
                      {item}
                    </span>
                  ))}
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}